import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import ByRoso from './pages/ByRoso';
import FSSC from './pages/FSSC';
import Events from './pages/Events';
import SidebarNav from './components/SidebarNav';

function App() {
  const location = useLocation();

  let appLayoutClass = 'app-layout';
  if (location.pathname.startsWith('/fssc')) {
    appLayoutClass += ' fssc-page-active';
  }

  return (
    <div className={appLayoutClass}>
      <SidebarNav />
      <div className="main-content-wrapper">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/byroso" element={<ByRoso />} />
          <Route path="/fssc" element={<FSSC />} />
          <Route path="/events" element={<Events />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
